import { useDebounceWithReset } from '@ijoin/components';
import { useGetAdminPlans, type GetAdminPlansParams } from '@ijoin/hooks';

import { useState } from 'react';

const PLAN_SEARCH_LIMIT = 50;

/** debounced server-side plan lookup shared by autocompletes and grid filter defs */
export const usePlanOptions = (
  advisoryOrganizationId: null | string | undefined,
  params?: GetAdminPlansParams
) => {
  const [search, setSearch] = useState('');
  const onSearch = useDebounceWithReset(setSearch, 400);

  const plans = useGetAdminPlans(
    advisoryOrganizationId ?? '',
    { search, sort: 'description', take: PLAN_SEARCH_LIMIT, ...params },
    {
      query: {
        enabled: !!advisoryOrganizationId,
        select: res =>
          res.data
            .filter(plan => plan.planId)
            .map(plan => ({
              label: plan.description ?? plan.planId,
              value: plan.planId
            }))
      }
    }
  );

  return {
    isLoading: plans.isFetching,
    onSearch,
    options: plans.data ?? []
  };
};
